// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    call,
    put,
} from 'redux-saga/effects';

import {
    GET_PART_INFO,
    getPartInfoSuccess,
    getPartInfoFail,
} from './../../../store/orderCreation';

import {
    actionStatusStarted,
    actionStatusFailed,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import DeviceDal from './../../../dal/DeviceDal';

export function* getPartInfo(request: any): IterableIterator<any> {
    const {
        deviceSerial,
        partSerial,
    } = request.payload;
    
    try {
        yield put(actionStatusStarted({actionName: `${GET_PART_INFO}-${deviceSerial}`}));

        const partInfo = yield call(
            DeviceDal.getDevice,
            partSerial
        );

        yield put(actionStatusSuccess({actionName: `${GET_PART_INFO}-${deviceSerial}`}));
        yield put(getPartInfoSuccess({
            deviceSerial,
            partSerial,
            data: partInfo,
        }));
    } catch (e) {
        yield put(actionStatusFailed({
            actionName: `${GET_PART_INFO}-${deviceSerial}`,
            data: {
                deviceSerial,
                partSerial,
            },
            error: e,
        }));
        yield put(getPartInfoFail({
            deviceSerial,
            partSerial,
        }));
    }
}
